import React, { Component, use } from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
import { getUrl } from '../globals/url';

import VoteForm from './vote-form';

import {
    GoogleReCaptchaProvider,
    withGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

// Wrap the VoteForm component with the Google ReCaptcha
// comes with the googleReCaptchaProps.executeRecaptcha which is needed for the VoteForm component
const VoteFormWithReCaptcha = withGoogleReCaptcha(VoteForm);

/**
 * Vote
 *
 * Parent class component that renders the step through forms
 *
 * @since   0.5
 * @package app\vote-form
 */
class Vote extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userIp: '',
            step: '',
            lastStep: '',
        };

        this.lookUpUserLocation = this.lookUpUserLocation.bind(this);
        this.lookUpUserClub = this.lookUpUserClub.bind(this);
    }

    /**
     * componentWillMount
     *
     * Set all the appropriate values needed by the Step Component
     *
     * @type   method
     * @since  0.5
     *
     * @param {n/a}
     * @return {n/a}
     */
    UNSAFE_componentWillMount() {
        const voteFormTemplate = document.querySelector('.voting-template');
        const ip = voteFormTemplate.dataset.ip;
        const club = voteFormTemplate.dataset.club;
        let road = voteFormTemplate.dataset.road
            ? voteFormTemplate.dataset.road
            : null;
        const currentStep = voteFormTemplate.dataset.step;
        const lastStep = voteFormTemplate.dataset.last_step;
        const clubId = voteFormTemplate.dataset.club_id;

        this.setState({
            userIp: ip,
            club: club,
            road: road,
            step: currentStep,
            lastStep: lastStep,
            clubId: clubId,
        });
    }

    /**
     * componentDidMount
     *
     * Check if we need to do an extra lookup for the user if they are on the
     * the Ontario club
     *
     * @type   method
     * @since  0.5
     *
     * @param {n/a}
     * @return {n/a}
     */
    componentDidMount() {
        const club_data = JSON.parse(this.state.club);

        // Run another location lookup if user is in the Ontario Club
        if (club_data.isOntario) {
            this.lookUpUserLocation();
        }
    }

    /**
     * lookUpUserLocation
     *
     * Detect the user's location using their IP
     *
     * @type   method
     * @since  0.5
     *
     * @param {n/a}
     * @return {n/a}
     */
    lookUpUserLocation() {
        const base_url = `${getUrl()}/api/location/`;
        const endpoint = `${base_url}${this.state.userIp}`;

        fetch(endpoint)
            .then((response) => {
                if (!response.ok) {
                    console.error(
                        'Location detection failed!',
                        response.status,
                        response.statusText
                    );

                    return null;
                }

                return response.json();
            })
            .then((data) => {
                if (!data?.body?.zip) {
                    return;
                }

                let useSample = data.body.region_code === 'AB';
                const postal_code = data.body.zip;

                this.lookUpUserClub(postal_code, useSample);
            });
    }

    /**
     * lookUpClub
     *
     * Detect the user's location using their IP
     *
     * @type   method
     * @since  0.5
     *
     * @param {string} postal_code
     * @param {boolean} useSample // Used for testing by AB users that don' have VPNS
     * @return {n/a}
     */
    lookUpUserClub(postal_code, useSample = false) {
        const sample_postal_code = ['L2G', 'K8N 5B9', 'P0L']; // Used if user is testing from AB
        let randomNumber = Math.floor(Math.random() * 2) + 0;
        const base_url = `${getUrl()}/api/club/lookup/`;

        if (useSample) {
            postal_code = sample_postal_code[randomNumber];
        }

        let endpoint = `${base_url}${postal_code}`;

        fetch(endpoint)
            .then((response) => {
                if (!response.ok) {
                    console.error(
                        `Failed to lookup user club: ${response.status} ${response.statusText}`
                    );

                    return null;
                }

                return response.json();
            })
            .then((data) => {
                if (!data?.body || typeof data.body !== 'object') {
                    return;
                }

                const clubLabelContainer =
                    document.getElementById('club-identifier');
                const { clubId, club } = data.body;

                if (!clubId || !clubLabelContainer) {
                    return;
                }

                const clubName =
                    club?.en?.meta?.club_identifier ||
                    club?.fr?.meta?.club_identifier;

                if (clubName) {
                    clubLabelContainer.innerText = clubName;
                }
            });
    }

    /**
     * Render
     *
     * For rendering the correct component on the DOM
     *
     * @type   method
     * @since  0.5
     *
     * @param {n/a}
     * @return {jsx} DOM object to render
     */
    render() {
        const { userIp, road, club, clubId, step, lastStep } = this.state;

        return (
            <GoogleReCaptchaProvider reCaptchaKey="6LdYXigkAAAAADEaTnBBWkeoytKmJaZot9ZrlA6q">
                <VoteFormWithReCaptcha
                    userIp={userIp}
                    road={road}
                    club={club}
                    clubId={clubId}
                    currentStep={step}
                    lastStep={lastStep}
                />
            </GoogleReCaptchaProvider>
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const votingWrapper = document.getElementById('voting-form-wrapper');

    if (votingWrapper) {
        ReactDOM.render(<Vote />, votingWrapper);
    }
});
